import Keycloak from "keycloak-js";
import { KEYCLOAK_BASE_URL } from "./app/utils";

const keycloak = new Keycloak({
    url: KEYCLOAK_BASE_URL,
    realm: "parkit",
    clientId: "parkit-user",
});
export default keycloak;